// extracted by mini-css-extract-plugin
export default {"root":"Rating_root__1pM19","stars":"Rating_stars__BLpzX","rate":"Rating_rate__24FOO","star":"Rating_star__t1qg7","light":"Rating_light__1sPyq"};